import {restHelperService} from "./rest-helper.service";

export const eventService = {
    getEvents,
    addEvent,
    participateEvent,
    getEventsNew
};

function getEventsNew(limit = 3, offset = 0, eventFilter = {}) {
    const request = {
        "limit": limit,
        "offset": offset
    };
    addFilterToRequest(request, eventFilter);

    return restHelperService.createGetRequest("/rest/events", request)
        .then(res => {
            let response = restHelperService.getResponse(res);
            return Promise.resolve(response);
        }).catch((res) => {
            return restHelperService.handleCatch(res)
        })
}

function addEvent(fieldId, timeStart, duration, ispublic, minParticipants, maxParticipants, endTime, difficulty, description, title) {
    const request = {
        "fieldId": fieldId,
        "timeStart": timeStart,
        "duration": duration,
        "public": ispublic,
        "minParticipants": minParticipants,
        "maxParticipants": maxParticipants,
        "endTime": endTime,
        "difficulty": difficulty,
        "description": description,
        "title": title
    };
    return restHelperService.createPostRequest("/rest/events", request)
        .then(res => {
            let response = restHelperService.getResponse(res);
            return Promise.resolve(response);
        }).catch((res) => {
            return restHelperService.handleCatch(res)
        })
}

function participateEvent(reservationId, participate = true) {
    const request = {
        "reservationId": reservationId,
        "state": (participate)?"accept":"decline"
    };
    return restHelperService.createPatchRequest("/rest/events", request)
        .then(res => {
            let response = restHelperService.getResponse(res);
            return Promise.resolve(response);
        }).catch((res) => {
            return restHelperService.handleCatch(res)
        })
}

function getEvents(isPublic = true, limit = 3, offset = 0, eventFilter = {}) {
    const request = {
        "public": isPublic,
        "limit": limit,
        "offset": offset
    };
    addFilterToRequest(request, eventFilter);

    return restHelperService.createGetRequest("/rest/events", request)
        .then(res => {
            let response = restHelperService.getResponse(res);
            return Promise.resolve(response);
        }).catch((res) => {
            return restHelperService.handleCatch(res)
        })
}

function addFilterToRequest(request, eventFilter) {
    if(eventFilter.creatorArray && eventFilter.creatorArray.length > 0) {
        request.multipleValueArrayCreator = {
            key: "creator",
            values: eventFilter.creatorArray
        }
    }
    if(eventFilter.fieldArray && eventFilter.fieldArray.length > 0) {
        request.multipleValueArrayField = {
            key: "fieldId",
            values: eventFilter.fieldArray
        }
    }
    if(eventFilter.userIdArray && eventFilter.userIdArray.length > 0) {
        request.multipleValueArrayUser = {
            key: "userId",
            values: eventFilter.userIdArray
        }
    }

    if(eventFilter.stateArray && eventFilter.stateArray.length > 0) {
        request.multipleValueArrayUser = {
            key: "state",
            values: eventFilter.stateArray
        }
    }
    if(eventFilter.sportIdArray && eventFilter.sportIdArray.length > 0) {
        request.multipleValueArraySport = {
            key: "sportId",
            values: eventFilter.sportIdArray
        }
    }
    if(eventFilter.fromDate) {
        request.fromDate = eventFilter.fromDate
    }
    if(eventFilter.toDate) {
        request.toDate = eventFilter.toDate
    }
    if(eventFilter.maxDistance && eventFilter.maxDistance > 0) {
        console.log(eventFilter.maxDistance)
        request.maxDistance = eventFilter.maxDistance
    }
    if(eventFilter.priceMin && eventFilter.priceMin > 0) {
        request.priceMin = eventFilter.priceMin
    }
    if(eventFilter.priceMax && eventFilter.priceMax > 0) {
        request.priceMax = eventFilter.priceMax
    }
    if(eventFilter.type) {
        request.type = eventFilter.type
    }
    if(eventFilter.sort) {
        request.sort = eventFilter.sort
    }
}
